import React from "react";

const Introduction = React.lazy(() => import('../views/Introduction'));
const Requirements = React.lazy(() => import('../views/Requirements'));
const Registration = React.lazy(() => import('../views/registration/Registration'));
const Application = React.lazy(() => import('../views/Application'));
const BusinessPlan = React.lazy(() => import('../views/BusinessPlan'));
const SelfAssessment = React.lazy(() => import('../views/SelfAssessment'));
const Reports = React.lazy(() => import('../views/Reports360'));
const GenericTraining = React.lazy(() => import('../views/GenericTraining'));
const CheckStatus = React.lazy(() => import('../views/preview/CheckStatus'));
const About = React.lazy(() => import('../views/About'));
const Faq = React.lazy(() => import('../views/Faq'));
const Exclusion = React.lazy(() => import('../views/ExclusionList'));
const Completed = React.lazy(() => import('../views/preview/SubmitStatus'));
const AssessmentCompleted = React.lazy(() => import('../views/preview/AssessmentCompleted'));
const BusinessPlanCompleted = React.lazy(() => import('../views/preview/BusinessPlanCompleted'));

const routes = [
    { path: "/registration", name: "Registration", component: Registration },
    { path: "/introduction", name: "Introduction", component: Introduction },
    { path: "/requirements", name: "Requirements", component: Requirements },
    { path: "/application", name: "Application", component: Application },
    { path: "/businessplan", name: "Business Plan", component: BusinessPlan },
    { path: "/selfassessment", name: "Self Assessment", component: SelfAssessment },
    { path: "/traininginfo", name: "Generic Training", component: GenericTraining },
    { path: "/360reports", name: "360 Reports", component: Reports },
    { path: "/checkstatus", name: "Check Status", component: CheckStatus },
    { path: "/guidelines", name: "Application Manual", component: About },
    { path: "/faq", name: "FAQ", component: Faq },
    { path: "/exclusion", name: "Exclusion List", component: Exclusion },
    { path: "/completed", name: "Completed", component: Completed },
    { path: "/assessmentcompleted", name: "Assessment Completed", component: AssessmentCompleted },
    { path: "/busplancompleted", name: "Business Plan Completed", component: BusinessPlanCompleted }
]
export default routes;